import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

interface MetricCardProps {
  label: string
  value: number | string
  icon?: ReactNode
  color?: 'red' | 'orange' | 'green' | 'blue' | 'indigo'
  subtext?: string
  loading?: boolean
}

const COLOR_CLASSES: Record<string, string> = {
  red: 'bg-red-50 border-red-200 text-red-700',
  orange: 'bg-orange-50 border-orange-200 text-orange-700',
  green: 'bg-green-50 border-green-200 text-green-700',
  blue: 'bg-blue-50 border-blue-200 text-blue-700',
  indigo: 'bg-indigo-50 border-indigo-200 text-indigo-700',
}

const COLOR_ICON: Record<string, string> = {
  red: 'text-red-400',
  orange: 'text-orange-400',
  green: 'text-green-400',
  blue: 'text-blue-400',
  indigo: 'text-indigo-400',
}

export function MetricCard({ label, value, icon, color = 'blue', subtext, loading }: MetricCardProps) {
  const colors = COLOR_CLASSES[color]
  const iconColor = COLOR_ICON[color]

  return (
    <div className={cn('rounded-lg border p-4 flex items-center gap-4', colors)}>
      {icon && <div className={cn('shrink-0', iconColor)}>{icon}</div>}
      <div className="min-w-0">
        <div className="text-2xl font-bold">{loading ? '–' : value}</div>
        <div className="text-sm opacity-75">{label}</div>
        {subtext && <div className="text-xs opacity-60 mt-0.5">{subtext}</div>}
      </div>
    </div>
  )
}
